import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { trackWhatsAppClick } from "@/lib/analytics";

export default function WhatsAppFab() {
  const { pathname } = useLocation();
  const [whatsapp, setWhatsapp] = useState("+96891291423");
  useEffect(() => {
    api.get("/settings").then((r) => {
      if (r.data?.whatsapp_number) setWhatsapp(r.data.whatsapp_number);
    }).catch(() => {});
  }, []);
  if (pathname === "/contact" || pathname.startsWith("/tours/")) return null;
  const link = `https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}`;
  return (
    <a
      data-testid="whatsapp-fab"
      href={link}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      onClick={() => trackWhatsAppClick("floating_button")}
      className="fixed bottom-3 right-3 md:bottom-6 md:right-6 z-30 bg-whatsapp hover:bg-whatsapp-dark text-white rounded-full shadow-soft w-11 h-11 md:w-14 md:h-14 flex items-center justify-center transition-all hover:scale-105"
    >
      <svg viewBox="0 0 24 24" className="w-5 h-5 md:w-[26px] md:h-[26px]" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.94 11.94 0 0012.04 0C5.5 0 .2 5.3.2 11.84c0 2.09.55 4.13 1.6 5.93L0 24l6.4-1.68a11.83 11.83 0 005.64 1.44h.01c6.54 0 11.84-5.3 11.84-11.84 0-3.16-1.23-6.13-3.37-8.44zM12.05 21.5h-.01a9.7 9.7 0 01-4.95-1.36l-.36-.21-3.8 1 1.02-3.7-.23-.38a9.66 9.66 0 01-1.48-5.01c0-5.36 4.37-9.72 9.74-9.72a9.7 9.7 0 016.88 2.85 9.66 9.66 0 012.85 6.88c0 5.36-4.37 9.65-9.66 9.65zm5.58-7.27c-.3-.15-1.8-.89-2.08-.99-.28-.1-.48-.15-.68.15-.2.3-.78.99-.96 1.19-.18.2-.36.22-.66.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.13-.13.3-.36.45-.54.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.07-.15-.68-1.64-.93-2.24-.24-.59-.5-.5-.68-.51l-.58-.01c-.2 0-.5.07-.77.36-.27.3-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.2 3.03.15.2 2.07 3.17 5.02 4.44.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.12.56-.08 1.8-.74 2.06-1.45.26-.7.26-1.3.18-1.44-.08-.13-.28-.2-.58-.35z"/>
      </svg>
    </a>
  );
}
